































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import { debounce } from 'lodash';

import {
  getPurchaseOrderStats,
} from '@/api';
import useAuth from '@/use/useAuth';
import usePurchaseOrder from '@/use/usePurchaseOrder';

import PanelWithPurchaseOrderItemTable from '@/components/PurchaseOrder/PanelWithPurchaseOrderItemTable.vue';

const ReceiveList = defineComponent({
  components: {
    PanelWithPurchaseOrderItemTable,
  },
  setup(props, { root }) {
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    const toCurrencyWithoutSign = (amount: number): string => (amount || 0).toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });

    const { en: statusList, th: statusDisplay } = usePurchaseOrder();
    const refetchQuery = ref(false);

    const filter = reactive({
      code: '',
      status: 'PENDING',
      date: undefined,
    });

    async function clickDateHandler(date: any) {
      if (filter.date === useFormat.date(date).computerShortDate()) {
        filter.date = undefined;
      } else {
        filter.date = useFormat.date(date).computerShortDate();
      }
      await pendingSearch();
    }

    const pendingSearch = debounce(async () => {
      refetchQuery.value = true;
    }, 250);

    const stats = reactive({
      total: 0,
      pending: 0,
      done: 0,
      cancelled: 0,
    });
    async function getStats() {
      const result = await getPurchaseOrderStats({ date: filter.date });
      stats.total = result.total;
      stats.pending = result.waiting;
      stats.done = result.done;
      stats.cancelled = result.cancelled;
    }

    onMounted(async () => {
      await getStats();
    });

    return {
      hasPermission,
      toCurrencyWithoutSign,

      pendingSearch,
      clickDateHandler,

      filter,
      statusList,
      statusDisplay,
      refetchQuery,

      stats,
    };
  },
});

export default ReceiveList;
